export const LocationIcon = () => {
  return (
    <svg
      width="16"
      height="19"
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9202 8.00923C14.9202 13.4183 7.92017 18.0547 7.92017 18.0547C7.92017 18.0547 0.920166 13.4183 0.920166 8.00923C0.920166 6.16477 1.65766 4.39586 2.97042 3.09163C4.28317 1.7874 6.06365 1.05469 7.92017 1.05469C9.77668 1.05469 11.5572 1.7874 12.8699 3.09163C14.1827 4.39586 14.9202 6.16477 14.9202 8.00923Z"
        stroke="#475569"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.92017 10.3274C9.20883 10.3274 10.2535 9.28953 10.2535 8.00923C10.2535 6.72894 9.20883 5.69105 7.92017 5.69105C6.6315 5.69105 5.58683 6.72894 5.58683 8.00923C5.58683 9.28953 6.6315 10.3274 7.92017 10.3274Z"
        stroke="#475569"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
